@if (loadedError) {
    <app-widgets-overlay [type]="loadedErrorReason"></app-widgets-overlay>
}
@if (!loadedError && loaded && !data) {
    <app-widgets-overlay type="no-match"></app-widgets-overlay>
}
@if (!loaded) {
    <div class="widget-page-loader"></div>
}
@if (loaded) {
    <div class="widget-container d-flex flex-column">
        <div class="widget-container__object">
            @if (!noTitle) {
                <h1 class="widget-title align-self-center">
                    {{ 'web.widget_correct_score' | translate }}
                </h1>
            }
            <div class="d-flex flex-column widget-form-participant-container">
                <div class="d-flex justify-content-between">
                    <app-chart-circle-somple
                        [percentage]="+sort[0]!['prct']!"
                        [text]="sort[0]!['score'] + ''"
                        data-cy="cs-sum-1"
                    >
                        {{ sort[0]!['prct'] | number: '1.0-0' }}%
                    </app-chart-circle-somple>
                    <app-chart-circle-somple
                        [percentage]="+sort[1]!['prct']!"
                        [text]="sort[1]!['score'] + ''"
                        data-cy="cs-sum-2"
                    >
                        {{ sort[1]!['prct'] | number: '1.0-0' }}%
                    </app-chart-circle-somple>
                    <app-chart-circle-somple
                        [percentage]="+sort[2]!['prct']!"
                        [text]="sort[2]!['score'] + ''"
                        data-cy="cs-sum-3"
                    >
                        {{ sort[2]!['prct'] | number: '1.0-0' }}%
                    </app-chart-circle-somple>
                </div>
            </div>
            <div class="d-flex flex-column widget-form-participant-container">
                <div class="d-flex justify-content-between">
                    <div class="widget-form-participant widget-form-participant--home" data-cy="csHome1">
                        {{ home[0]!['prct'] }}%
                    </div>
                    <div class="widget-form-participant widget-form-participant--home2" data-cy="csHome2">
                        {{ home[1]!['prct'] }}%
                    </div>
                    <div class="widget-form-participant widget-form-participant--home3" data-cy="csHome3">
                        {{ home[2]!['prct'] }}%
                    </div>
                </div>
                <div class="d-flex">
                    <div
                        class="widget-form-participant-bar widget-form-participant-bar--home1 text-center"
                        [style.width.%]="34"
                    >
                        {{ home[0]!['score'] }}
                    </div>
                    <div
                        class="widget-form-participant-bar widget-form-participant-bar--home2 text-center"
                        [style.width.%]="32"
                    >
                        {{ home[1]!['score'] }}
                    </div>
                    <div
                        class="widget-form-participant-bar widget-form-participant-bar--home3 text-center"
                        [style.width.%]="34"
                    >
                        {{ home[2]!['score'] }}
                    </div>
                </div>
                @if (data?.home; as p) {
                    <div class="text-center widget-form-participant--home f-14">
                        {{ p.name }}
                    </div>
                }
            </div>
            <div class="d-flex flex-column widget-form-participant-container">
                <div class="d-flex justify-content-between">
                    <div class="widget-form-participant widget-form-participant--away" data-cy="csAway1">
                        {{ away[0]!['prct'] }}%
                    </div>
                    <div class="widget-form-participant widget-form-participant--away2" data-cy="csAway2">
                        {{ away[1]!['prct'] }}%
                    </div>
                    <div class="widget-form-participant widget-form-participant--away3" data-cy="csAway3">
                        {{ away[2]!['prct'] }}%
                    </div>
                </div>
                <div class="d-flex">
                    <div
                        class="widget-form-participant-bar widget-form-participant-bar--away1 text-center"
                        [style.width.%]="34"
                    >
                        {{ away[0]!['score'] }}
                    </div>
                    <div
                        class="widget-form-participant-bar widget-form-participant-bar--away2 text-center"
                        [style.width.%]="32"
                    >
                        {{ away[1]!['score'] }}
                    </div>
                    <div
                        class="widget-form-participant-bar widget-form-participant-bar--away3 text-center"
                        [style.width.%]="34"
                    >
                        {{ away[2]!['score'] }}
                    </div>
                </div>
                @if (data?.away; as p) {
                    <div class="text-center widget-form-participant--away f-14">
                        {{ p.name }}
                    </div>
                }
            </div>
            <div class="w-100 text-center widget-form-participant-text app-word-nowrap">
                {{ 'web.num_of_matches' | translate }} ({{ num }})
            </div>
            <div class="widget-logo d-flex justify-content-center mt-4">
                <img
                    [src]="'/img/' + client.getName() + '.png'"
                    [alt]="client.getName()"
                    data-cy="logo"
                    class="widget-logo-client"
                />
            </div>
        </div>
    </div>
}
